'use strict';

angular.module('shiftTraderApp')
  .factory('OAuthKeys', function ($injector, ServerUrls, $q) {
    var cacheExpiration = 60 * 60;
    var cacheLastSet = null;
    var record = null;

    function isCacheValid() {
      return !_.isNull(cacheLastSet) &&
      (cacheLastSet + cacheExpiration) > moment.utc().unix();
    }

    function updateCache(rec) {
      record = rec;
      cacheLastSet = moment.utc().unix();
    }

    function getKeys() {
      var deferred = $q.defer();
      var $http = $injector.get('$http');

      if (isCacheValid()) {
        deferred.resolve(record);
      } else {
        $http.get(ServerUrls.current.railsApi + 'keys')
          .then(function(response) {
            updateCache(response.data);
            deferred.resolve(response.data);
          }, function(response) {
            deferred.reject(response);
          });
      }

      return deferred.promise;
    }

    return {
      getKeys: getKeys
    };
  });
